export default __webpack_public_path__ + "static/media/Group 13469.051369c6.svg";